import exerciseHelpers from "./exercise";
import assessmentHelpers from "./assessment";

const helpers = {
  ...exerciseHelpers,
  ...assessmentHelpers,
};

export default helpers;

export const generateQueryParams = (obj: any) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

export const getLabelFromKey = (key: string) => {
  if (!key) return null;
  return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};
